import { GetFunction } from "../utils/axios_connection";
import UrlApi from "../utils/Url";

export const GetWhatWeDo = async ({ callback }) => {
  try {
    let link = UrlApi.what_we_do.get;
    const response = await GetFunction({
      data: {},
      Route: link,
      showalert: false,
    });
    callback(response?.data);
  } catch (err) {
    callback(false);
  }
};

export const GetClients = async ({ callback }) => {
  try {
    let link = UrlApi.clients.get;
    const response = await GetFunction({
      data: {},
      Route: link,
      showalert: false,
    });
    callback(response?.data);
  } catch (err) {
    callback(false);
  }
};

export const GetServices = async ({ callback }) => {
  try {
    let link = UrlApi.service.get;
    const response = await GetFunction({
      data: {},
      Route: link,
      showalert: false,
    });
    callback(response?.data);
  } catch (err) {
    callback(false);
  }
};
export const GetIntroCall = async ({ callback }) => {
  try {
    let link = UrlApi.intro_call.get;
    const response = await GetFunction({
      data: {},
      Route: link,
      showalert: false,
    });
    callback(response?.data);
  } catch (err) {
    callback(false);
  }
};

export const GetService = async ({ callback }) => {
  try {
    let link = UrlApi.services.get;
    const response = await GetFunction({
      data: {},
      Route: link,
      showalert: false,
    });
    callback(response?.data);
  } catch (err) {
    callback(false);
  }
};

export const GetBlog = async ({ callback }) => {
  try {
    let link = UrlApi.blog.get;
    const response = await GetFunction({
      data: {},
      Route: link,
      showalert: false,
    });
    console.log({ response });
    callback(response?.data);
  } catch (err) {
    callback(false);
  }
};

export const GetProjects = async ({ callback }) => {
  try {
    let link = UrlApi.projects.get;
    const response = await GetFunction({
      data: {},
      Route: link,
      showalert: false,
    });
    console.log({ response });
    callback(response?.data);
  } catch (err) {
    callback(false);
  }
};

export const GetTestimonials = async ({ callback }) => {
  try {
    let link = UrlApi.testimonials.get;
    const response = await GetFunction({
      data: {},
      Route: link,
      showalert: false,
    });
    callback(response?.data);
  } catch (err) {
    callback(false);
  }
};

export const GetAboutUs = async ({ callback, id }) => {
  try {
    let link = UrlApi.about_us.get;
    const response = await GetFunction({
      data: {},
      Route: link,
      showalert: false,
    });
    callback(response?.data);
  } catch (err) {
    callback(false);
  }
};

export const GetServicesInfo = async ({ callback, id }) => {
  try {
    let link = `${UrlApi.services_info.get}?id=${id}`;
    const response = await GetFunction({
      data: {},
      Route: link,
      showalert: false,
    });

    callback(response?.data);
  } catch (err) {
    callback(false);
  }
};
export const GetSettings = async ({ callback }) => {
  try {
    let link = UrlApi.settings.get;
    const response = await GetFunction({
      data: {},
      Route: link,
      showalert: false,
    });
    callback(response?.data);
  } catch (err) {
    callback(false);
  }
};

export const GetCaseStudy = async ({ callback }) => {
  try {
    let link = UrlApi.case_study.get;
    const response = await GetFunction({
      data: {},
      Route: link,
      showalert: false,
    });
    callback(response?.data);
  } catch (err) {
    callback(false);
  }
};

export const getSelectedBlog = async ({ callback, id }) => {
  try {
    let link = `${UrlApi.blog_info.get}?id=${id}`;
    const response = await GetFunction({
      data: {},
      Route: link,
      showalert: false,
    });
    callback(response?.data);
  } catch (err) {
    callback(false);
  }
};

export const getSelectedService = async ({ callback, id }) => {
  try {
    let link = `${UrlApi.selected_service.get}?id=${id}`;
    const response = await GetFunction({
      data: {},
      Route: link,
      showalert: false,
    });
    callback(response?.data);
  } catch (err) {
    callback(false);
  }
};

export const getSelectedProjects = async ({ callback, id }) => {
  try {
    let link = `${UrlApi.projects_info.get}?id=${id}`;
    const response = await GetFunction({
      data: {},
      Route: link,
      showalert: false,
    });
    callback(response?.data);
  } catch (err) {
    callback(false);
  }
};

export const getSelectedCaseStudy = async ({ callback, id }) => {
  try {
    let link = `${UrlApi.case_study_info.get}?id=${id}`;
    const response = await GetFunction({
      data: {},
      Route: link,
      showalert: false,
    });
    callback(response?.data);
  } catch (err) {
    callback(false);
  }
};
